import { getCookie } from "mpfe-utils"
import { importLogin } from './login'

export const bindMobile = () => {
    const ppinf = getCookie('ppinf')
    const ppok = getCookie('ppok')
    const needBindMobile = !!ppok && !ppinf
    if(!needBindMobile) return
    importLogin()
}